import React, { useState, useEffect } from 'react'
import { Card, Button, Col, Row, Tag, message, Spin } from 'antd'
import { QcTypeMap, QcType, QcSchemeStatusMap } from './constants'
import PreviewCompliance from './components/preview-compliance'
import PreviewMoc from './components/preview-moc'
import PreviewScenarioTag from './components/preview-scenario-tag'
import { AIQualityCheckPlanDetailItem } from 'src/types/ai-quality-check'
import { getAIQualityCheckPlanDetail, submitSchemeOptimize } from '@services/ai-quality-check'

const PreiewSchemePage = ({ qcType, qcId, onEdit }: { qcType: number, qcId: number, onEdit: (id: number) => void }) => {
  const [qcPlanDetail, setQcPlanDetail] = useState<AIQualityCheckPlanDetailItem | null>(null)
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    (async () => {
      if (qcId) {
        setLoading(true)
        const [res, err] = await getAIQualityCheckPlanDetail({ plan: [{ planId: qcId }] })
        if (err) {
          message.error(`获取方案详情失败:${err.message}`)
          setQcPlanDetail(null)
        } else {
          setQcPlanDetail(res.list.find(item => item.id === qcId) || null)
        }
        setLoading(false)
      }
    })()
  }, [qcId])

  const handleEdit = () => {
    onEdit(qcId)
  }
  const handleSubmit = async () => {
    const [, err] = await submitSchemeOptimize({ planId: qcId })
    if (err) {
      message.error(`提交调优失败:${err.message}`)
    } else {
      message.success('提交调优成功')
      setTimeout(() => {
        window.open('/config/quality-check-scheme', '_self')
      }, 1000)
    }
  }
  const handleCancelSubmit = () => {
    window.open('/config/quality-check-scheme', '_self')
  }
  const renderContent = (qcType: number) => {
    switch (qcType) {
      case QcType.compliance:
        return (<PreviewCompliance qcPlanDetail={qcPlanDetail} />)
      case QcType.moc:
        return (<PreviewMoc qcPlanDetail={qcPlanDetail} />)
      case QcType.scenarioTag:
        return (<PreviewScenarioTag qcPlanDetail={qcPlanDetail} />)
      default:
        return null
    }
  }
  return (
    <>
      <Card>
        <Spin spinning={loading}>
          <Row align="middle">
            <Col span={2}>
              <div style={{ textAlign: 'right', marginRight: 6 }}>方案名称:</div>
            </Col>
            <Col span={21} style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <h3>{qcPlanDetail?.name}</h3>
                <Button type="dashed" size="small" style={{ borderColor: '#1890ff', color: '#1890ff', marginLeft: 20 }}>
                  #{QcTypeMap[qcPlanDetail?.type]}
                </Button>
                <Tag color={QcSchemeStatusMap[qcPlanDetail?.status as keyof typeof QcSchemeStatusMap]?.color} style={{ marginLeft: 10 }}>{QcSchemeStatusMap[qcPlanDetail?.status as keyof typeof QcSchemeStatusMap]?.text}</Tag>
              </div>
              <Button onClick={handleEdit}>编辑方案</Button>
            </Col>
          </Row>
          <div>
            {renderContent(qcType)}
          </div>
          <Row justify="center" gutter={20} style={{ marginTop: 20 }}>
            <Col>
              <Button onClick={handleCancelSubmit}>暂不提交</Button>
            </Col>
            <Col>
              <Button type="primary" onClick={handleSubmit}>提交调优</Button>
            </Col>
          </Row>
        </Spin>
      </Card>
    </>
  )
}

export default PreiewSchemePage
